import { addLocale, setDefaultLang } from 'c-3po';

import ukLocale from './../../i18n/uk.po';

addLocale('uk', ukLocale);
setDefaultLang('ru');
